import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, _, u ) => {

	return {
		menuPaper: {
			borderRadius: "1.5rem"
		},
		root: {
			display: "flex"
		},
		headerContainer: {
			display         : "flex",
			justifyContent  : "space-between",
			borderBottom    : theme.other.darkMode ? "none" : `solid 1px ${ theme.other.colors.border.primary }`,
			padding         : "1.75rem",
			alignItems      : "center",
			backgroundColor : theme.other.colors.dialog.primary
		},
		modalBody: {
			// height    : "180px",
			// overflowY : "auto"
			backgroundColor : theme.other.colors.dialog.secondary,
			padding         : "1.75rem"
		},
		titleContainer: {
			display    : "flex",
			filter     : "opacity(0.60)",
			fontWeight : 100
		},
		btnContainer: {
			display      : "flex",
			alignItems   : "baseline",
			alignContent : "space-around",
			flexWrap     : "wrap",
			maxWidth     : "400px"
		},
		tagHeader: {
			fontSize: "1.5rem"
		},
		centerContainer: {
		},
		btnContent: {
			display: "flex"
		},
		svgIcon: {
			width       : "15px",
			marginRight : "5px"
		},
		topBtnActive: {
			cursor    : "pointer",
			width     : "fit-content",
			margin    : "5px 10px",
			padding   : "2px 10px",
			border    : "1px solid #126bd5",
			"&:hover" : {
				borderColor: "#126bd5"
			},
			borderRadius         : "3px",
			textAlign            : "center",
			textTransform        : "capitalize",
			fontWeight           : "500",
			fontSize             : "14px",
			color                : "#126bd5",
			WebkitBackgroundClip : "padding-box", /* for Safari */
			backgroundClip       : "padding-box", /* for IE9+, Firefox 4+, Opera, Chrome */
			display              : "inline-flex",
			alignItems           : "center"
		},
		chipGroup: {
			display : "flex",
			gap     : "1rem"
		},
		btn: {
			cursor: "pointer"
		},
		btnActive: {
			cursor      : "pointer",
			marginRight : "1.25rem",
			padding     : "2px 10px",
			border      : "1px solid #126bd5",
			"&:hover"   : {
				borderColor: "#126bd5"
			},
			borderRadius  : "3px",
			textAlign     : "center",
			textTransform : "capitalize",
			fontWeight    : "500",
			fontSize      : "14px",
			color         : "#126bd5",
			display       : "inline-block"
		},
		dialogRoot: {
			[u.smallerThan ( "lg" )]: {
				width  : "350px",
				height : "210px"
			},
			[u.largerThan ( "md" )]: {
				width  : "350px",
				height : "210px"
			},
			[u.largerThan ( "lg" )]: {
				width  : "400px",
				height : "210px"
			}
		},
		subtmitContainer: {
			width   : "50%",
			padding : "12px 12px 12px 10px"
		},
		submitBtn: {
			float         : "right",
			textTransform : "initial",
			background    : theme.other.paletteNew.mainGradient,
			margin        : "10px",
			boxShadow     : "none !important",
			padding       : "5px 25px",
			borderRadius  : "5px"
		},
		submitBtnInactive: {
			float         : "right",
			textTransform : "initial",
			background    : theme.other.paletteNew.mainGradient,
			margin        : "10px",
			boxShadow     : "none !important",
			filter        : "opacity(0.5)"
		},
		cancelBtnTop: {
			margin        : "5px 10px",
			float         : "right",
			fontSize      : "1.4rem",
			fontWeight    : "500",
			fontStretch   : "normal",
			fontStyle     : "normal",
			lineHeight    : "normal",
			letterSpacing : "normal",
			textAlign     : "left",
			color         : "#126bd5",
			cursor        : "pointer"

		},
		contentContainer: {
			padding: "5px"
		},
		cancelBtn: {
			margin        : "15px 10px",
			float         : "right",
			fontSize      : "1.4rem",
			fontWeight    : "500",
			fontStretch   : "normal",
			fontStyle     : "normal",
			lineHeight    : "normal",
			letterSpacing : "normal",
			textAlign     : "left",
			color         : "#126bd5",
			cursor        : "pointer"

		}
	};
} );
